module.exports = __webpack_public_path__ + "img/Frueher-380@2x.b69ccba6.jpg";